var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 56,
    viewBox: "0 0 57 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 23.3327V18.666C14.5 10.9427 16.8333 4.66602 28.5 4.66602C40.1667 4.66602 42.5 10.9427 42.5 18.666V23.3327",
    stroke: "#FEFEFE",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4998 43.1667C31.7215 43.1667 34.3332 40.555 34.3332 37.3333C34.3332 34.1117 31.7215 31.5 28.4998 31.5C25.2782 31.5 22.6665 34.1117 22.6665 37.3333C22.6665 40.555 25.2782 43.1667 28.4998 43.1667Z",
    stroke: "#FEFEFE",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1665 51.334H16.8332C7.49984 51.334 5.1665 49.0007 5.1665 39.6673V35.0007C5.1665 25.6673 7.49984 23.334 16.8332 23.334H40.1665C49.4998 23.334 51.8332 25.6673 51.8332 35.0007V39.6673C51.8332 49.0007 49.4998 51.334 40.1665 51.334Z",
    stroke: "#FEFEFE",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.3c4faa9c4efe57b84f153ce1fd7b9aec.svg";
export { ForwardRef as ReactComponent };